import { ErrorBoundariesService } from "core/service";
import BaseRepository from "core/repository/base.repository";
import uncaught from "uncaught";
import { mapStackTrace } from "sourcemapped-stacktrace";

class ErrorBoundariesRepository extends BaseRepository {
  syncable = false;

  getEntityIdentifier() {
    return "error-boundary";
  }

  resourceName() {
    return "erro";
  }

  getServiceProvider() {
    return ErrorBoundariesService;
  }

  alert(message) {
    if (process.env.REACT_APP_SEND_ALERTS !== "0") {
      this.mService.alert(message);
    }
  }

  async additionalPrepare() {
    uncaught.start();
    uncaught.addListener(error => {
      mapStackTrace(error.stack || "", mappedStack => {
        const errorMessage = `\`${error.message}\`\n\`\`\`${mappedStack.join(
          "\n"
        )}\`\`\``;
        this.alert(errorMessage);
      });
    });
  }
}

export default new ErrorBoundariesRepository();



// WEBPACK FOOTER //
// ./src/core/repository/error-boundaries.repository.js